import { Component } from "@angular/core";

@Component({
	selector: "stages-popup-content",
	templateUrl: "./popup-content.component.html",
	styleUrls: ["./popup-content.component.scss"],
})
export class PopupContentComponent {}
